module.exports = __webpack_public_path__ + "static/media/A (14).61ea5d36.jpg";